const token = localStorage.getItem('default_auth_token');
export default token;
